<div class="icon-wrapper" [attr.data-test-id]="'kr-icon-wrapper'">
  <i class="move-item-icon" ui-icon uiType="move" uiTheme="outline"> </i>
  <span class="contributor-icon" *ngIf="type === 'goal'">
    <i class="icon-goal" [a11yTitle]="'objective' | localize" ui-icon uiType="goal" uiTheme="fill"></i>
  </span>
  <span class="contributor-icon" *ngIf="type === 'metric' && !isContributingMetric">
    <i class="icon-metric" [a11yTitle]="'key_result' | localize" ui-icon uiType="metric" uiTheme="fill"></i>
  </span>
  <span class="contributor-icon" *ngIf="type === 'metric' && isContributingMetric">
    <i class="icon-metric" [a11yTitle]="'key_result' | localize" ui-icon uiType="contributing-metric" uiTheme="fill"></i>
  </span>
</div>
<div class="content-wrapper" [ngClass]="{ 'children-kr-attainment': type === 'goal' && goal.attainmentTypeString === 'average_children_kr' }">
  <label
    class="metric-title"
    *ngIf="type === 'metric'"
    [attr.data-test-id]="'key-result-item'"
    [attr.aria-describedby]="'kr-' + contributorMetric.id + '-description'"
    (keydown)="onKeyResultNamePress($event)"
    (click)="onKeyResultNamePress()"
    tabindex="0">
    {{ contributorMetric.name }}
  </label>
  <div class="kr-a11y-description" [id]="'kr-' + (metric?.id || '') + '-description'">{{ metricAriaLabelDescription }}</div>
  <div class="goal-title" *ngIf="type === 'goal' && contributorGoal ? !contributorGoal.obfuscated : false" (click)="openGoal(contributorGoal.id)">{{ contributorGoal.name }}</div>
  <div class="gh-siv-private" *ngIf="type === 'goal' && contributorGoal.obfuscated">{{ "private_goal" | localize }}</div>
  <div *ngIf="type === 'metric'" [id]="'metric-target-container-' + contributorMetric.id">
    <div class="metric-target" *ngIf="contributorMetric.manualType !== 'boolean'">
      <okr-metric-bar-target [metric]="contributorMetric"></okr-metric-bar-target>
    </div>
    <div class="metric-target" *ngIf="contributorMetric.manualType === 'boolean'">
      <okr-metric-bar-boolean [metric]="contributorMetric"></okr-metric-bar-boolean>
    </div>
  </div>
</div>
<confidence-label
  *ngIf="contributorMetric?.confidence"
  [id]="'confidence-preview-' + contributorMetric.id"
  [confidenceValue]="contributorMetric?.confidence?.value"
  [attr.data-test-id]="'confidenceLevelText'"
  ui-tooltip>
</confidence-label>
<ui-assignee-avatar-group [uiAlignRight]="true" uiSize="xs">
  <ui-assignee-avatar *ngFor="let assigneeId of ownerIds" [fromAssigneeId]="assigneeId" />
</ui-assignee-avatar-group>
<div class="contributor-progress-bar" *ngIf="type === 'metric'">
  <okr-metric-bar-progress [metric]="contributorMetric" [coloringStrategy]="coloringStrategy" [planningSession]="planningSession"></okr-metric-bar-progress>
</div>
<div class="contributor-progress-bar" *ngIf="type === 'goal'">
  <goal-bar-progress [goal]="contributorGoal" [coloringStrategy]="coloringStrategy" [planningSession]="planningSession"></goal-bar-progress>
</div>
<div class="contributor-attainment">
  <div class="metric-attainment" *ngIf="coloringStrategy !== 'colors'">{{ formatValue(contributorMetric ? contributorMetric.attainment : contributorGoal.attainment) }}%</div>
  <div class="metric-attainment coloring" *ngIf="coloringStrategy === 'colors'" [style.background]="contributorMetric ? contributorMetric.color : contributorGoal.color">
    {{ formatValue(contributorMetric ? contributorMetric.attainment : contributorGoal.attainment) }}%
  </div>
</div>
<button
  *ngIf="type === 'metric' && canUpdateMetric()"
  [id]="'update-metric-button-' + (metric?.id || '')"
  [attr.data-test-id]="'goal-view-metric-' + (metric?.id || '') + '-update-button'"
  (click)="onUpdateMetric()"
  ui-button
  uiShape="round"
  uiSize="small">
  {{ "update" | localize }}
</button>
<span *ngIf="contributorMetric">
  <metric-contributor-dropdown
    *ngIf="!contributorMetric?.obfuscated && type === 'metric'"
    [context]="metricContributorContext"
    [actionHandlers]="metricContributorActionHandlers"
    [attr.data-test-id]="'goal-view-metric-' + (metric?.id || '') + '-dropdown-menu-component'">
  </metric-contributor-dropdown>
</span>
<div class="fake-update-button" *ngIf="type === 'goal' || !canUpdateMetric()"></div>
<span *ngIf="contributorGoal">
  <gh-dropdown
    *ngIf="this.contributorGoal && type === 'goal'"
    [menuItems]="dropdownGoalContributorItems"
    dropdownMenuClass="dropdown-actions-menu"
    iconName="menu-horizontal"
    data-test-id="dropdown-actions-menu">
  </gh-dropdown>
</span>
